import ActionButton, {
  ActionButtonProps,
} from '@/components/elements/ActionButton/ActionButton';
import { useTranslations } from 'use-intl';
import { ReactNode } from 'react';
import useWatchConnect from '@/application/write/analytics/useWatchConnect';

const ConnectButton = ({
  blendColor = 'after:bg-gray-50',
  className,
  children,
  account,
  chain,
  openAccountModal,
  openChainModal,
  openConnectModal,
  mounted,
}: Partial<Pick<ActionButtonProps, 'blendColor' | 'className'>> & {
  children?: ReactNode;
  account: { displayName: string } | undefined;
  chain: { unsupported?: boolean } | undefined;
  openAccountModal: () => void;
  openChainModal: () => void;
  openConnectModal: () => void;
  mounted: boolean;
}) => {
  const t = useTranslations('Connect');

  useWatchConnect(account);

  if (!mounted || !account || !chain) {
    return (
      <ActionButton
        onClick={openConnectModal}
        blendColor={blendColor}
        className={className}
      >
        {children || t('connect')}
      </ActionButton>
    );
  }
  if (chain.unsupported) {
    return (
      <ActionButton
        onClick={openChainModal}
        blendColor={blendColor}
        className={`${className} bg-pink-500`}
      >
        {children || t('changeNetwork')}
      </ActionButton>
    );
  }
  return (
    <ActionButton
      onClick={openAccountModal}
      blendColor={blendColor}
      className={className}
    >
      {children || t('user', { username: account.displayName })}
    </ActionButton>
  );
};

export default ConnectButton;
